import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a3b683"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridlistausuarios" }
const _hoisted_2 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header ta-c" }, "Digitación Últimos 3 Días", -1))
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Listado de Prefacturas")
], -1))
const _hoisted_7 = { class: "table table-hover" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Valor")
  ])
], -1))
const _hoisted_9 = { class: "t izq bold" }
const _hoisted_10 = { class: "bold" }
const _hoisted_11 = { class: "bold der blue" }
const _hoisted_12 = { class: "bold izq bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der blue" }, null, -1))
const _hoisted_14 = { class: "bold der blue" }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Listado de Facturas")
], -1))
const _hoisted_17 = { class: "table table-hover" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Valor")
  ])
], -1))
const _hoisted_19 = { class: "t izq bold" }
const _hoisted_20 = { class: "bold" }
const _hoisted_21 = { class: "bold der blue" }
const _hoisted_22 = { class: "bold izq bold" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold der blue" }, null, -1))
const _hoisted_24 = { class: "bold der blue" }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { class: "table table-hover" }
const _hoisted_27 = { class: "bold izq bold" }
const _hoisted_28 = { class: "bold der blue" }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Cuentas por Cobrar")
], -1))
const _hoisted_31 = { class: "table table-hover" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "mith" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite" }, "Facturado"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Pagado"),
    /*#__PURE__*/_createElementVNode("th", { class: "cwhite der" }, "Balance")
  ])
], -1))
const _hoisted_33 = { class: "bold" }
const _hoisted_34 = { class: "bold der blue" }
const _hoisted_35 = { class: "bold der blue" }
const _hoisted_36 = { class: "bold der blue" }
const _hoisted_37 = { class: "bold izq bold" }
const _hoisted_38 = { class: "bold der blue" }
const _hoisted_39 = { class: "bold der blue" }
const _hoisted_40 = { class: "bold der blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      (
        this.$store.state.user.type == 'Power User' ||
          this.$store.state.user.type == 'Administrador' ||
          this.$store.state.user.type == 'Digitador'
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.digitacion, (elemento, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(elemento.count), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.$store.state.user.type == 'Médico')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.documentos2, (documento, index) => {
                return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString($options.formatDate(documento.fechaEfectivo)), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(documento.descCliente), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString($options.formatNumber(documento.prefactura)), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_12, " Total: " + _toDisplayString($options.formatNumber2(this.totales.documentos2)), 1),
                  _hoisted_13,
                  _createElementVNode("td", _hoisted_14, _toDisplayString($options.formatNumber(this.totales.factura2)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.$store.state.user.type == 'Médico')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("table", _hoisted_17, [
              _hoisted_18,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.documentos, (documento, index) => {
                return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_19, _toDisplayString($options.formatDate(documento.fechaEfectivo)), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(documento.descCliente), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString($options.formatNumber(documento.factura)), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_22, " Total: " + _toDisplayString($options.formatNumber2(this.totales.documentos)), 1),
                  _hoisted_23,
                  _createElementVNode("td", _hoisted_24, _toDisplayString($options.formatNumber(this.totales.factura)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.$store.state.user.type == 'Médico')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_27, " Total General: " + _toDisplayString($options.formatNumber2(
                  this.totales.documentos2 + this.totales.documentos
                )), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString($options.formatNumber(this.totales.factura + this.totales.factura2)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.$store.state.user.type == 'Médico')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("table", _hoisted_31, [
              _hoisted_32,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.balancesClientes, (balance, index) => {
                return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_33, _toDisplayString(balance._id.descCliente), 1),
                    _createElementVNode("td", _hoisted_34, _toDisplayString($options.formatNumber(balance.factura)), 1),
                    _createElementVNode("td", _hoisted_35, _toDisplayString($options.formatNumber(balance.recibo)), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString($options.formatNumber(balance.factura - balance.recibo)), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_37, " Total: " + _toDisplayString($options.formatNumber2(this.totales.cantBalancesClientes)), 1),
                  _createElementVNode("td", _hoisted_38, _toDisplayString($options.formatNumber(this.totales.facturaBalancesClientes)), 1),
                  _createElementVNode("td", _hoisted_39, _toDisplayString($options.formatNumber(this.totales.reciboBalancesClientes)), 1),
                  _createElementVNode("td", _hoisted_40, _toDisplayString($options.formatNumber(this.totales.balanceBalancesClientes)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}